import { Link } from "react-router-dom";

export default function IconsContact(props) {
    return (
        <article>
            <article>
                <Link to={props.linkeSoc} target="_blank"><i className={props.iconContact}></i></Link>
            </article>
            <article>
                <p style={{fontSize:"14.5px"}}>{props.subEmail}</p>
                <p style={{fontSize:"14.5px"}}>{props.email}{props.lasEmail}</p>
            </article>
        </article>
    );
}